import { render } from "./index.vue?vue&type=template&id=08a4b66e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=08a4b66e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08a4b66e"],['__file',"src/views/Membership/component/Favourites/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "08a4b66e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('08a4b66e', __exports__)) {
    api.reload('08a4b66e', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=08a4b66e&scoped=true", () => {
    api.rerender('08a4b66e', render)
  })

}


export default __exports__